import KpiCard from '../common/KpiCard';
import useMetric from '../../hooks/useMetric';
import { formatPercent } from '../../utils/format';

export default function ConversionRateKpiCard() {
  const { status, data, error, retry } = useMetric('conversionRate');
  // Change is shown in percentage points (pp) because the metric itself is a percentage.
  const delta = data ? Math.round((data.value - data.previous) * 10) / 10 : null;
  return (
    <KpiCard
      testId="kpi-conversion-rate" title="Conversion Rate" icon="bi-bullseye" tone="success" to="/analytics"
      status={status} error={error} onRetry={retry} emptyText="Not enough data to compute a rate."
      value={data && formatPercent(data.value)} delta={delta}
      sparkline={data?.sparkline} footnote="Leads / visitors"
    />
  );
}
